export default "__VITE_ASSET__jfLR_vxL__"